/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { ModalConfirm } from "@nordcloud/gnui";
import { useDeleteCustomer } from "~/views/customers/Actions/DeleteCustomer/useDeleteCustomer";

type DeleteCustomerProps = {
  customerId: string;
  customerName: string;
  isDeleteCustomerModalOpen: boolean;
  closeModal: () => void;
  onSuccess?: () => void;
};

function DeleteCustomer({
  customerId,
  customerName,
  isDeleteCustomerModalOpen,
  closeModal,
  onSuccess,
}: DeleteCustomerProps) {
  const [deleteCustomer] = useDeleteCustomer({
    onSuccess: () => {
      closeModal();
      onSuccess?.();
    },
  });

  return (
    <>
      <ModalConfirm
        onClose={closeModal}
        isOpen={isDeleteCustomerModalOpen}
        confirm={() => deleteCustomer(customerId)}
        actionLabel="Delete"
        contentLabel={`Delete ${customerName}`}
      >
        Are you sure you want to delete {customerName}
      </ModalConfirm>
    </>
  );
}

export { DeleteCustomer };
